import taskgraphLogsLinks from './taskgraphLogsLinks';

export default taskgraphLogsLinks;
